module.exports = __webpack_public_path__ + "img/payment-error.4e8150f7.png";